<template>
   <div class="container" id="devis-content" :style="{backgroundColor: Theme['gray-100']}">
        <div class="content">
            <div id="devis-content1">
                <div class="d-flex justify-content-between mb-8">
                    <div class="text-start pe-5">
                        <h5>{{ company?.society?.name?.toUpperCase() }}</h5>
                        <p>{{ company?.society?.address }} , {{ company?.society?.city }}, {{ company?.country?.name }}
                            <br>{{ company?.society?.society_email }}
                            <br>{{ company?.society?.society_phone }} 
                            <br>N° IFU {{ company?.society?.ifu_number }}
                            <br>N° RCCM {{ company?.society?.rccm_number }}
                        </p>
                        <h4>{{ $t('devis.devis') }}: N° {{ estimate?.estimate_number }}</h4>
                        <p class="otherStyle mt-3">{{ $t('invoices.date_creation') + ': ' + formatDate(new Date(estimate?.estimate_date))  }}</p>
                    </div>
                    <div class="text-end" style="text-align: right;">
                        <div class="py-10 mb-5" v-if="company?.society?.logo_url">
                            <img :src="company?.society?.logo_url" alt="Logo" style="width: 100px; height: auto;">
                        </div>
                        <p>{{$t('invoices.to')}}
                            <br><span class="fw-bolder">{{ estimate?.contact?.fullname }}</span>
                            <br>{{ contactPhone }}
                            <br>{{ estimate?.contact?.email }}
                        </p>
                    </div>
                </div>
                <div style="min-height: 400px;">
                    <div class="table-responsive">
                        <table class="table text-center mb-5">
                            <thead>
                                <tr>
                                    <th>N°</th>
                                    <th>{{$t('invoices.description')}}</th>
                                    <th>{{$t('invoices.qty')}}</th>
                                    <th>{{$t('invoices.price')}}</th>
                                    <th>{{$t('invoices.rem')}}</th>
                                    <th>{{$t('invoices.taxes')}}</th>
                                    <th>{{$t('invoices.amount')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <Item v-for="(item, index) in estimate?.items" :key="index" :item="item" :index="index" :currency="estimate?.currency?.symbol"/>
                            </tbody>
                        </table>
                    </div>
                    <div class="d-flex justify-content-between otherStyle mb-2">
                            <div class="flex-item py-5 flex-column" style="background-color: #fff;">
                                <div class="d-flex justify-content-between">
                                    <div class="text-start ps-3">
                                        {{ $t('invoices.totalTax') }}
                                    </div>
                                    <div class="text-start pe-6">
                                        {{ $formatLocalAmount(parseFloat(estimate.total_tax))  }} {{ estimate?.currency?.symbol }}
                                    </div>
                                </div>
                            </div>
                            <div class="spacer"></div>
                            <div class="flex-item py-5 flex-column" style="background-color: #fff;">
                                <div class="d-flex justify-content-between">
                                    <div class="text-start ps-3">
                                        {{ $t('invoices.subtotal') }}
                                    </div>
                                    <div class="text-start pe-6">
                                        {{ $formatLocalAmount(parseFloat(estimate.sub_total))  }} {{ estimate?.currency?.symbol }}
                                    </div>
                                </div>
                            </div>
                    </div>
                    <div class="d-flex justify-content-between py-3 otherStyle mb-2">
                        <div class="flex-item py-5 flex-column" style="background-color: #fff;">
                            <div class="d-flex justify-content-between">
                                <div class="text-start ps-3">
                                    {{ $t('invoices.totalRem') }}
                                </div>
                                <div class="text-start pe-6">
                                    {{ $formatLocalAmount(parseFloat(estimate.discount))  }} {{ estimate?.currency?.symbol }}
                                </div>
                            </div>
                        </div>
                        <div class="spacer"></div>
                        <div class="flex-item py-5 flex-column" style="background-color: #fff;">
                            <div class="d-flex justify-content-between">
                                <div class="text-start ps-3">
                                    {{ $t('invoices.totalTtc') }}
                                </div>
                                <div class="text-start pe-6">
                                    {{ $formatLocalAmount(parseFloat(estimate.total))  }} {{ estimate?.currency?.symbol }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between mb-2">
                        <div class="flex-item py-5 otherStyle flex-column" >
                        </div>
                        <div class="spacer"></div>
                        <div class="flex-item py-5 flex-column" style="background-color: var(--bs-primary); color: #fff;">
                            <div class="d-flex justify-content-between">
                                <div class="text-start ps-3">
                                    {{ $t('invoices.total') }}
                                </div>
                                <div class="text-start pe-6">
                                {{ $formatLocalAmount(parseFloat(estimate.total))  }} {{ estimate?.currency?.symbol }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="devis-content2">
                <div class="d-flex justify-content-between mt-10">
                    <div class="text-start">
                        <h4 style="color: #F07817;">{{ $t('devis.terms') }}</h4>
                        <div>
                            <span  style="font-weight: 500;">{{$t('crm.estimate.label.validity')}} : {{ estimate?.validity_period }} {{$t('crm.estimate.label.day')}}</span>
                            <br><span v-if="estimate?.paymentType?.name" style="font-weight: 500;"> {{$t('crm.estimate.label.paymentType')}} : {{ estimate?.paymentType?.name }} </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="pt-5 mb-2" id="devis-content3" :style="{borderTop: '1px solid '+Theme['gray-300']}">
            <div class="d-flex text-start mb-3">
                <span class="fw-bold me-2" v-if="company?.society?.headquarters_address">{{ $t('company.label.headquarters_address') }}: {{ company?.society?.headquarters_address }} / </span>
                <span class="fw-bold" v-if="company?.society?.address">{{ company?.society?.address }}</span>
                <span class="fw-bold me-1" v-if="company?.society?.city">, {{ company?.society?.city }} </span>
                <span class="fw-bold" v-if="company?.country?.name"> {{ company?.country?.name }}</span>
                <span class="fw-bold" v-if="company?.website"> / {{ company?.website }}</span>
            </div>
            <div class="d-flex text-start">
                <span v-if="company?.bankData?.bank_name" class="fw-bold me-2">{{ company?.bankData?.bank_name }} </span>
                <span v-if="company?.bankData?.bic" class="fw-bold me-2">{{ $t('bank.label.bic')?.toUpperCase() }}: {{ company?.bankData?.bic }} </span>
                <span v-if="company?.bankData?.rib" class="fw-bold me-2">{{ $t('bank.label.rib')?.toUpperCase() }}: {{ company?.bankData?.rib }} </span>
                <span v-if="company?.bankData?.iban" class="fw-bold">{{ $t('bank.label.iban')?.toUpperCase() }}: {{ company?.bankData?.iban }}</span>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { Theme } from "@/composables/theming";
    import {computed, defineProps} from 'vue'
    import {useStore} from "vuex";
    import {useLocales} from "@/composables/locales";
    import {formatDate, $formatLocalAmount} from "@/mixins/Helpers";
    import Item from "./Item";

    const { locale } = useLocales()
    const store = useStore()

    const props = defineProps({
        estimate: { type: Object, required: true }
    })

    const company = computed(() => store.getters['company/getCompanyInfos'])

    const contactPhone = computed(() => {
        if(props.estimate?.contact) {
            const phones = props.estimate?.contact?.phone
            if(phones.length)
            return phones[0]
            return ""
        }
        return ""
    })

    
</script>

<style scoped>
  .container {
    width: 100%;
    max-width: 800px;
    margin: 20px auto;
    border: 1px solid #e0e0e0;
    border-radius: 5px;
  }
  .table th {
    background-color: var(--bs-primary);
    color: #ffffff;
  }
  .table tr {
    background-color: #fff;
    margin-bottom: 5px;
    border-bottom: 3px solid #F2F3F4;
  }
  .otherStyle{
      color: var(--bs-primary);
      font-weight: 500;
  }
  .img_class{
      border: 2px dashed var(--bs-primary);
  }
  .flex-item {
       flex: 1;
   }
   .spacer {
       min-width: 20px;
   }
</style>